import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#EDEDED',
    padding: theme.spacing(14),
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
    marginBottom: theme.spacing(0.25),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4),
    },
  },
  title: {
    fontSize: 30,
    fontWeight: 900,
    color: '#981248',
    '& > span:hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  },
}));

function SearchNoDataFound(props) {
  const classes = useStyles();
  const { title } = props;
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <Typography component="div" className={classes.title}>
        {title || t('SEARCH.NO_DATA_FOUND')}
      </Typography>
    </div>
  );
}

SearchNoDataFound.propTypes = {
  title: PropTypes.string,
};

export default SearchNoDataFound;
